const getPerc = (num1, num2) => Math.round((num1 / num2) * 100);

export default getPerc;
